import React from 'react';
import { Card } from 'antd';
import { FileTextOutlined, CalendarOutlined } from '@ant-design/icons';
import { formatDateTime } from '../../../../utils/functions';

const EnhancedActivityLogCardView = ({ record, onCardClick }) => {
    return (
        <Card
            hoverable
            className="h-full relative shadow-sm hover:shadow-md transition-all duration-200 border-gray-100 hover:border-primary/20"
            onClick={() => onCardClick && onCardClick(record)}
        >
            <div className="flex items-start gap-2.5 sm:gap-3">
                <div className="flex-shrink-0 w-8 h-8 sm:w-9 sm:h-9 rounded-lg bg-primary/5 flex items-center justify-center">
                    <FileTextOutlined className="text-primary text-base sm:text-lg" />
                </div>
                <div className="flex-1 min-w-0 py-0.5">
                    <h4 className="text-[13px] sm:text-sm font-semibold text-gray-800 mb-0.5 leading-tight line-clamp-2">
                        {record.description || "No Description"}
                    </h4>
                    <div className="flex items-center text-gray-400 text-[11px] sm:text-xs">
                        <CalendarOutlined className="mr-1 sm:mr-1.5" />
                        <span>{formatDateTime(record.dateAsPerUserTimezone)}</span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedActivityLogCardView;
